// The internal app reads `clients.filters.*` dynamically; a type-level completeness check against
// its ClientsFilterType lives next to that type (SONeuWebApp/src/pages/clients/clients/Clients.types.ts),
// because shared code cannot import app types.
const clients = {
  title_one: "1 Kund:in gefunden",
  title_other: "{{count}} Kund:innen gefunden",
  title_zero: "Keine Kund:innen gefunden",
  titleUnavailable: "Kundensuche",
  subtitle: "Es gibt noch weitere Kund:innen die aufgrund der Limitierung nicht angezeigt werden",
  createClient: "Kund:innen anlegen",
  searchClients: "Kund:innen suchen",
  noResults:
    "Mit den aktuellen Suchkriterien konnten keine Kund:innen gefunden werden. \nBitte überprüfe deine Suchangaben und Filter.",
  searchError: "Die Kundensuche konnte nicht durchgeführt werden — bitte später erneut versuchen.",
  table: {
    id: "EDV#",
    firstName: "Vorname",
    lastName: "Nachname",
    birthday: "Geb. Dat.",
    socialSecurityNumber: "SV-Nummer",
    telephoneNumber: "Telefonnummer",
    status: "Status",
    personalBankruptcyFileNumber: "Privatinsolvenz-Aktenzeichen",
  },
  deleteAllFilters: "Alle Filter löschen",
  editor: "Bearbeiter: {{userName}}",
  openClient: "Kund:in {{name}} öffnen.",
  openClientInNewTab: "Kund:in {{name}} in neuem Tab öffnen.",
  openCaseNote: "Aktenvermerk {{label}} öffnen.",
  update: {
    updateCounselorSuccess: "Bearbeiter:in wurde geändert",
  },
  create: {
    dialogTitle: "Kund:in anlegen",
    creationDate: "Erstmeldedatum",
    contactSource: "Kontaktquelle",
    comment: "Bemerkung",
    salutation: "Anrede",
    title: "Titel",
    name: "Vorname",
    lastName: "Familienname",
    formerLastName: "Früherer Familienname",
    street: "Straße",
    houseNumber: "Hausnummer/Stiege/Tür",
    zipCode: "Plz",
    city: "Ort",
    country: "Land",
    email: "E-Mail",
    phone: "Telefonnummer",
    birthday: "Geburtsdatum",
    insuranceNumber: "Versicherungsnummer",
    employmentStatus: "Arbeitssituation",
    submit: "Anlegen",
    createAnyway: "Trotzdem anlegen",
    duplicateTitle: "Mögliche Dublette gefunden",
    duplicateDescription:
      "Es existiert bereits ein:e Kund:in mit gleichem Namen und Geburtsdatum. Bitte prüfen, ob es sich um dieselbe Person handelt.",
    duplicateAddress: "Adresse",
    duplicateOpenInNewTab: "Kund:in {{name}} in neuem Tab öffnen",
    invalidEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein (z. B. name@example.at)",
    invalidInsuranceNumber: "Ungültige Versicherungsnummer",
    dateMaxToday: "Das Datum darf nicht in der Zukunft liegen.",
    birthdayTooOld: "Das Geburtsdatum darf nicht länger als 120 Jahre zurückliegen",
    invalidZipCode: "Die Postleitzahl muss numerisch sein",
    phoneInvalid: "Die Telefonnummer ist ungültig",
    successfullyAdded: "Kund:in erfolgreich angelegt",
    saveFailed: "Kund:in konnte nicht angelegt werden.",
    streetSearchHint: "Mindestens 3 Zeichen eingeben",
    streetSearchNoResults: "Keine Adresse gefunden",
    streetSearchLoading: "Adressen werden gesucht …",
    streetSearchError: "Adresssuche zurzeit nicht verfügbar",
  },
  search: {
    dialogTitle: "Kund:innen suchen",
    showMatchingResults: "Passende Treffer anzeigen",
    salutation: "Anrede",
    title: "Titel",
    name: "Name oder Teil davon",
    birthday: "Geburtsdatum",
    socialSecurityNumber: "SV-Nummer",
    idNumber: "EDV-Nummer oder Teil davon",
    srvFileNumber: "SRV-Aktenzahl oder Teil davon",
    court: "Gericht",
    street: "Straße oder Teil davon",
    zipCode: "PLZ",
    city: "Ort oder Teil davon",
    nationality: "Staatsbürgerschaft",
    mediaInquiry: "Medienanfrage",
    caseNoteDateFrom: "AV Datum von",
    caseNoteDateTo: "AV Datum bis",
    caseNoteKeyword: "Stichwort",
    currentStatus: "Status",
    caseNumber: "Privatinsolvenz-Aktenzeichen",
  },
  client: {
    tabs: {
      overview: "Übersicht",
      masterData: "Stammdaten",
      clientNote: "Notizen",
      notes: "Vermerke",
      debtSettlement: {
        label: "Schuldenregulierung",
        assetList: "Vermögensverzeichnis",
        claims: "Verbindlichkeiten",
        bankruptcyChecklist: "Konkurs Checkliste",
        compensation: "Ausgleich",
        personalBankruptcyPetition: "Privatkonkursantrag",
        srvProceeding: "Verfahren",
      },
    },
    createNote: "Vermerk erstellen",
    overview: {
      currentAgreement: "Aktuelle Vereinbarung",
      debt: "Verschuldung",
      estimatedDebt: "Geschätzte Verschuldung",
      actualDebt: "Tatsächliche Verschuldung (berechneter Wert)",
      estimatedNumberOfCreditors: "Geschätzte Anzahl Gläubiger",
      actualNumberOfCreditors: "Tatsächliche Anzahl Gläubiger (berechneter Wert)",
      saveSuccess: "Übersicht erfolgreich gespeichert",
    },
    clientNote: {
      noticeTitle: "Wichtige Informationen zu den Notizen",
      noticeText:
        "Achtung: Das, was Sie hier eingeben, wird nicht automatisch von Ihrem Kunden bzw. Ihrer Kundin gelesen. Sie können hier also keine Nachrichten für Ihren Kunden oder Ihre Kundin hinterlassen. Wenn Sie Nachrichten für Ihren Kunden oder Ihre Kundin haben, so rufen Sie ihn bzw. sie an.",
      cardTitle: "Notizen (für Kund:in sichtbar)",
      note: "Notiz",
      saveSuccess: "Notizen erfolgreich gespeichert",
      loading: "Notizen werden geladen",
      loadError: "Die Notizen konnten nicht geladen werden. Bitte versuchen Sie es später erneut.",
    },
    masterData: {
      goalsResults: "Ziele/Ergebnisse",
      measuresCauses: "Massnahmen/Ursachen",
      statusCounselor: "Status und Bearbeiter:in",
      statusCounselorSection: {
        status: "Status",
        counselor: "Bearbeiter:in",
        statusHistory: "Statushistorie",
        created: "Erstellt",
        successfullySaved: "Status und Bearbeiter erfolgreich gespeichert",
      },
      volunteerAssignment: "Ehrenamtliche Zuweisung",
      clientAccess: "Kund:innen Zugang",
      callbackAmbulanz: "Rückruf-Ambulanz erstellen",
      callbackAmbulanzDialog: {
        title: "Rückruf Ambulanz",
        text: "Soll der Rückruf in die Ambulanz gestellt werden?",
        success: "Rückruf erfolgreich erstellt",
      },
      callbackAssignment: "Rückruf-Aufgabe erstellen",
      callbackAssignmentDialog: {
        title: "Rückruf Aufgabe",
        text: "Soll ein Rückruf erstellt werden?",
        successAssignmentForCounselor: "Rückruf-Aufgabe für Berater:in erstellt",
        successAssignmentForSubstitute: "Rückruf-Aufgabe für die Vertretung erstellt",
        successAmbulanz: "Kein:e verfügbare:r Berater:in – Rückruf in die Ambulanz gestellt",
      },
      createAssignment: "Aufgabe erstellen",
      personalData: {
        label: "Persönliche Daten",
        comment: "Bemerkung",
        initialRegistrationDate: "Erstmeldedatum",
        contactSource: "Kontaktquelle",
        qualification: "Qualifikation",
        placeOfBirth: "Geburtsort",
        nationality: "Staatsbürgerschaft",
        maritalStatus: "Familienstand",
        livingSituation: "Wohnsituation",
        mediaInquiry: "Medienanfrage",
        addEmail: "E-Mail-Adresse hinzufügen",
        removeEmail: "E-Mail-Adresse entfernen",
        emailRequired: "E-Mail fehlt",
        addPhoneNumber: "Telefonnummer hinzufügen",
        removePhoneNumber: "Telefonnummer entfernen",
        phoneRequired: "Telefonnummer fehlt",
        successfullySaved: "Persönliche Daten erfolgreich gespeichert",
        amsAssignmentConsented: "AMS Zuweisung zugestimmt",
        performAmsAssignment: "AMS Zuweisung durchführen",
        amsAssignment: {
          success: "AMS Zuweisung erfolgreich durchgeführt",
          error: "AMS Zuweisung konnte nicht durchgeführt werden",
          firstNameMissing: "AMS Zuweisung nicht möglich: Vorname fehlt",
          lastNameMissing: "AMS Zuweisung nicht möglich: Nachname fehlt",
          insuranceNumberMissing: "AMS Zuweisung nicht möglich: Sozialversicherungsnummer fehlt",
          insuranceNumberNotUsable:
            "AMS Zuweisung nicht möglich: Die Sozialversicherungsnummer ist unvollständig — es werden entweder alle zehn Stellen oder die vierstellige Nummer samt Geburtsdatum benötigt",
          zipCodeMissing: "AMS Zuweisung nicht möglich: PLZ fehlt",
          alreadyBooked: "AMS Zuweisung bereits erfolgreich durchgeführt",
          saveFirst: "AMS Zuweisung erst nach dem Speichern der Änderungen möglich",
          unconfirmed: "AMS Zuweisung abgeschickt, das Ergebnis wurde nicht bestätigt — bitte im eAMS-Portal prüfen",
          outcomePending:
            "AMS Zuweisung offen: eine bereits abgeschickte Zuweisung ist noch nicht bestätigt — bitte im eAMS-Portal prüfen",
          sidNotConfigured: "AMS Zuweisung nicht möglich: In den AMS-Parametern ist keine SID hinterlegt",
          noVidForZipCode: "AMS Zuweisung nicht möglich: Für diese PLZ ist in den AMS-Parametern keine VID hinterlegt",
          requestFailed: "AMS Zuweisung konnte nicht an das eAMS übermittelt werden",
          writesDisabled: "AMS Zuweisung ist in dieser Umgebung deaktiviert",
        },
      },
    },
    caseNotes: {
      translationTool: "Übersetzungstool",
      openSrv: "§ SRV eröffnen",
      openSrvUnavailable: "Dieses Edikt kann nur über Edikte & OZUFs übernommen werden.",
      openSrvLoadFailed: "Die Ediktsdaten konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
      downloadCaseFile: "Akt herunterladen",
      downloadingCaseFile: "Archiv wird erstellt",
      createAvAssignment: "AV-Aufgabe erstellen",
      createNote: "Vermerk erstellen",
      searchPlaceholder: "Vermerke durchsuchen",
      overviewPlaceholder: "Kein Aktenvermerk vorhanden",
      openDetailedOverview: "Detaillierte Übersicht öffnen",
      popoutNotFound: "Aktenvermerk nicht gefunden",
      previewNotAvailable: "Vorschau nicht verfügbar",
      previewNotReady: "Vorschau wird noch generiert",
      previewFailed: "Vorschau konnte nicht erstellt werden",
      printFailed: "Vermerk konnte nicht gedruckt werden",
      appointmentStatus: {
        ATTENDED: "Wahrgenommen",
        CANCELLED_OR_RESCHEDULED: "Abgesagt/Verschoben",
        NO_SHOW: "Nicht erschienen",
        RESCHEDULED_BY_STAFF: "Von SB verschoben",
      },
      appointmentStatusLabel: "Gesprächsinformation: {{status}}",
      filter: {
        all: "Alle anzeigen",
        appointmentNotesOnly: "Nur Termine anzeigen",
      },
      form: {
        type: "Art AV",
        appointmentStatus: "Gesprächsinformation",
        date: "Datum",
        time: "Zeit",
        location: "Ort",
        content: "Bericht",
        result: "Ergebnis",
        fileName: "Dateiname",
        template: "Vorlage",
        noTemplates: "Keine Vorlagen vorhanden",
        templateOverwriteTitle: "Bericht überschreiben?",
        templateOverwriteText:
          "Das Feld „Bericht“ enthält bereits Text. Soll er durch die ausgewählte Vorlage ersetzt werden?",
        templateResolveError: "Platzhalter der Vorlage konnten nicht ersetzt werden",
      },
      creationDialog: {
        title: "Aktenvermerk erstellen",
        successfullyAdded: "Aktenvermerk erfolgreich erstellt",
      },
      editDialog: {
        title: "Aktenvermerk bearbeiten",
        successfullyUpdated: "Aktenvermerk erfolgreich aktualisiert",
      },
      deleteDialog: {
        title: "Aktenvermerk löschen",
        text: "Möchten Sie diesen Aktenvermerk wirklich löschen? Diese Aktion kann nicht mehr rückgängig gemacht werden.",
        successfullyDeleted: "Aktenvermerk erfolgreich gelöscht",
        deleteFailed: "Aktenvermerk konnte nicht gelöscht werden",
      },
    },
    sms: {
      sendSms: "SMS Senden",
      dialog: {
        title: "SMS senden",
        selectTemplate: "SMS-Vorlage wählen",
        recipientNumber: "Nummer",
        messageContent: "Nachricht",
        send: "Nachricht senden",
        successMessage: "Nachricht gesendet an: {{recipientNumber}}",
        errorMessage: "SMS konnte nicht gesendet werden",
        noPhoneNumbers: "Keine Telefonnummern vorhanden",
        textLength: "Textlänge: {{length}}",
        textLengthWithSegments: "Textlänge: {{length}} ({{segments}} x SMS)",
      },
    },
    email: {
      sendEmail: "E-Mail Senden",
      dialog: {
        title: "E-Mail senden",
        recipientEmail: "E-Mail-Adresse",
        selectTemplate: "E-Mail-Vorlage wählen",
        subject: "Betreff",
        messageContent: "Nachricht",
        openInMail: "In Mail öffnen",
        resolveError: "Platzhalter der Vorlage konnten nicht ersetzt werden",
        caseNoteError: "Aktenvermerk konnte nicht erstellt werden – die E-Mail wurde nicht geöffnet",
      },
    },
    templates: {
      uploadLinkRequired: "Diese Vorlage enthält einen Upload-Link. Bitte aktivieren Sie zuerst den Kundenupload.",
    },
    appointmentCreation: {
      createAppointment: "Termin erstellen",
      dialog: {
        title: "Termin erstellen",
        modeToggleAriaLabel: "Terminauswahl",
        freeSlotsMode: "Freie Termine",
        manualEntryMode: "Datum/Uhrzeit eingeben",
        purpose: "Zweck",
        counselor: "Berater:in",
        startDate: "Datum von",
        startTime: "Uhrzeit von",
        endDate: "Datum bis",
        endTime: "Uhrzeit bis",
        location: "Ort",
        selectPurposeHint: "Bitte zuerst einen Zweck wählen, um freie Termine anzuzeigen.",
        selectCounselorHint: "Bitte eine Berater:in wählen, um freie Termine anzuzeigen.",
        noFreeSlots: "Keine freien Termine für die gewählte Kombination aus Zweck und Berater:in vorhanden.",
        slotsLoadError: "Die freien Termine konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
        contactsLoadError: "Die Kontaktdaten der Kund:in konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
        loadingSlots: "Freie Termine werden geladen",
        loadingContacts: "Kontaktdaten werden geladen",
        slotListAriaLabel: "Freie Termine",
        submitButton: "Termin erstellen",
        successMessage: "Termin erfolgreich erstellt",
        notificationFailedMessage:
          "Termin erstellt — die Benachrichtigung an die Kund:in konnte nicht versendet werden. Bitte kontaktieren Sie die Kund:in manuell.",
      },
    },
    moreOptions: "Weitere Optionen",
    clientDetails: "Kund:innen-Details",
    status: "Status",
    emptyStatus: "(leer)",
    idNumber: "EDV-Nr.",
    clientAccess: "Online Zugang",
    insolvencyProceedings: "Verfahren",
    debtSettlement: {
      hasWarnings: "Es gibt offene Hinweise",
      assetInventory: {
        personalData: "Persönliche Daten",
        relatives: "Angehörige",
        income: "Einkommen",
        expenses: "Ausgaben",
        ownClaims: "Eigene Forderungen",
        assets: "Vermögen",
        otherPropertyRights: "Andere Vermögensrechte",
        donations: "Schenkungen",
        sectionIncomplete: "Es fehlen noch Angaben",
        entriesMissing: "Es wurde noch kein Eintrag erfasst",
        documents: {
          markAsRead: "Als gelesen markieren",
          markAsUnread: "Als ungelesen markieren",
          readIndicator: "Gelesen",
        },
        documentsOverview: {
          title: "Dokumente",
          sectionTitle_zero: "{{title}}",
          sectionTitle_one: "{{title}} ({{count}})",
          sectionTitle_other: "{{title}} ({{count}})",
          goToSection: 'Zum Bereich „{{section}}"',
          uploadInto: 'In „{{title}}" hochladen...',
          fileActions: 'Aktionen für "{{fileName}}"',
          successfullySaved: "Dokumente erfolgreich gespeichert",
        },
        section1: {
          personalDataTitle: "Persönliche Daten",
          causesTitle: "Ursachenschilderung",
          causesHelpText:
            "Geben Sie in 5 bis 7 Zeilen ein: Wann haben die Schulden begonnen? Weshalb wurden Sie gemacht? Warum konnten Sie nicht mehr zahlen?",
          causesLabel: "Ursachenschilderung",
          salaryAccountTitle: "Gehaltskontoverbindung",
          beruf: "Beruf oder Beschäftigung",
          berufRequired: "Das Feld 'Beruf oder Beschäftigung' ist nicht ausgefuellt",
          eingaengeRequired: "Das Feld 'Eingänge auf dieses Konto' ist nicht ausgefuellt",
          bankConnection: "Bankverbindung",
          bankName: "Name der kontoführenden Bank",
          incomings: "Eingänge auf dieses Konto",
          hasOwnAccountQuestion: "Haben Sie ein eigenes Girokonto?",
          hasFurtherAccountQuestion: "Haben Sie ein weiteres Konto?",
          overdrawnQuestion: "Ist Ihr Konto aktuell überzogen, d.h. im Minus?",
          placeOfBirthInfo:
            "Wenn Sie nicht in Österreich geboren wurden, geben Sie bitte auch an, in welchem Land Sie geboren wurden.",
          accountQuestionInfo:
            '"Ja" ist nur dann anzugeben, wenn Sie aktuell ein Konto haben, auf das ein Teil oder das gesamte Einkommen bzw. Beihilfen (z.B. Lohn, Pension, Leistung des AMS, Familienbeihilfe, Pflegegeld etc.) überwiesen wird.\n\nWenn Sie nur ein oder mehrere alte Konten haben, die überzogen sind und die Sie nicht mehr verwenden, so wählen Sie bitte "Nein".\n\nWenn Sie zur Zeit das Konto eines anderen mitbenutzen und selbst nicht Kontoinhaber/in sind, so wählen Sie bitte "Nein".',
          incomingsInfo: "Geben Sie hier bitte an, welche Eingänge es auf dieses Konto gibt.",
          overdrawnWarningParagraph1:
            'Wenn Sie dieses überzogene Konto nicht mehr verwenden, d.h. Ihr Einkommen kommt nicht auf dieses Konto, so beantworten Sie bitte die Frage weiter oben, ob Sie ein eigenes Girokonto in Verwendung haben, mit "Nein".',
          overdrawnWarningParagraph2:
            "Wenn Sie ein Konto in Verwendung haben, das überzogen ist, ist weder ein außergerichtlicher Ausgleich noch ein Konkursantrag möglich.",
          overdrawnWarningParagraph3:
            "Entweder wird der Kontoüberzug abgebaut und das Konto nicht mehr überzogen oder das Konto muss aufgegeben werden (Ihr Einkommen wird dann auf ein Konto überwiesen, das nicht überzogen ist bzw. bar oder mit der Post ausbezahlt).",
          noticeTitle: "Wichtige Informationen zum Vermögensverzeichnis",
          noticeText:
            'Das Vermögensverzeichnis ist zusammen mit der Gläubigerliste zentraler Bestandteil eines Schuldenregulierungsverfahrens ("Privatkonkurs"). Die gemachten Angaben müssen <strong>vollständig</strong> und <strong>richtig</strong> sein.\n\nSowohl das Gericht als auch die am Verfahren beteiligten Gläubiger müssen sich auf die von Ihnen gemachten Angaben stützen. Deshalb können falsche Angaben im Vermögensverzeichnis auch strafrechtliche Folgen haben (§ 292a Strafgesetzbuch).',
          glossaryLink: "Zum Lexikon",
          glossaryLinkAria: "Zum Lexikon (öffnet in einem neuen Tab)",
          successfullySaved: "Persönliche Daten erfolgreich gespeichert",
          bankStatement: {
            title: "Kontoauszug",
            uploadHint: "Aktuellen Kontoauszug hochladen oder hierher ziehen",
            missing: "Es wurde noch kein aktueller Kontoauszug hochgeladen!",
            markAsRead: "Als gelesen markieren",
            markAsUnread: "Als ungelesen markieren",
            readIndicator: "Gelesen",
            fileActions: 'Aktionen für "{{fileName}}"',
          },
          maintenance: {
            title: "Unterhaltspflichten",
            countLabel: "Zahl der Unterhaltspflichten",
            info: 'Die Anzahl der Unterhaltspflichten ergibt sich aus den unter "Angehörige" erfassten Personen und wird bei der Berechnung des pfändbaren Einkommens berücksichtigt.',
            emptyList:
              "Die einzelnen Unterhaltspflichten (Art und Geburtsdatum) werden hier angezeigt, sobald die Angehörigen erfasst sind.",
            countHeader_one: "{{count}} Unterhaltspflicht:",
            countHeader_other: "{{count}} Unterhaltspflichten:",
            entry_one: "{{relationship}}, geb. am {{birthDate}}, Alter: {{count}} Jahr",
            entry_other: "{{relationship}}, geb. am {{birthDate}}, Alter: {{count}} Jahre",
            entryWithoutBirthDate: "{{relationship}}",
            relationshipMissing: "Beziehung nicht angegeben",
            changeLink: "Änderungen können hier vorgenommen werden",
          },
        },
        incomeTab: {
          saveSuccess: "Einkommen erfolgreich gespeichert",
          validation: {
            payerIncomplete:
              "Antwort fehlt bzw. ist nicht vollständig. Geben Sie bitte den Namen und die komplette Adresse ein.",
            checkIncome: "Überprüfen Sie bitte das Einkommen",
            duplicateMonth:
              "Bitte prüfen Sie die Monatsauswahl: derselbe Monat wurde mehrfach gewählt (falscher Monat).",
          },
          selfEmployment: {
            title: "Allgemeine Fragen",
            hasSelfEmploymentIncome: "Haben Sie Ansprüche aus selbstständiger Erwerbstätigkeit?",
            description: "Beschreibung der Selbstständigkeit:",
            monthlyIncome:
              "Wie hoch sind die durchschnittlichen monatlichen Einkünfte nach Abzug der Abgaben aus dieser Selbstständigkeit?",
            notInCalculation: "Diese Angabe fließt nicht in die Pfändungsberechnung ein.",
          },
          seizableAmount: {
            title: "Pfändungsberechnung aufgrund der vorhandenen Angaben",
            parametersMissing:
              "Die Berechnungsparameter sind in den Einstellungen nicht vollständig hinterlegt, daher kann der pfändbare Betrag nicht berechnet werden.",
            remainingIncome: "Das verbleibende Einkommen beträgt {{amount}}",
            income12: "monatliches Gesamteinkommen, 12 mal jährlich ausbezahlt",
            income14: "monatliches Gesamteinkommen, 14 mal jährlich ausbezahlt",
            nonSeizableIncome: "monatliches unpfändbares Einkommen",
            subsistenceAmount12: "unpfändbarer Grundbetrag, 12 mal jährlich",
            subsistenceAmount14: "unpfändbarer Grundbetrag, 14 mal jährlich",
            fromSettings: "aus den Einstellungen — nur durch Supervisor:in änderbar",
            maintenanceObligationCount: "berücksichtigte Unterhaltspflichten",
            fromRelatives: "aus Tab 2 „Angehörige“",
            result: {
              bothSeizable:
                "Es sind monatlich {{amount12}} (12 mal jährlich) sowie {{amount14}} (14 mal jährlich) pfändbar.",
              seizable12: "Es sind monatlich {{amount}} (12 mal jährlich) pfändbar.",
              seizable14: "Es sind monatlich {{amount}} (14 mal jährlich) pfändbar.",
              nothingSeizableAtTotal: "Bei diesem monatlichen Gesamteinkommen von {{total}} ist nichts pfändbar.",
              nothingSeizable_zero: "Bei diesem Einkommen ist aktuell nichts pfändbar.",
              nothingSeizable_one:
                "Bei diesem Einkommen und der angegebenen Unterhaltspflicht ist aktuell nichts pfändbar.",
              nothingSeizable_other:
                "Bei diesem Einkommen und den angegebenen Unterhaltspflichten ist aktuell nichts pfändbar.",
            },
            explanation: {
              intro: "Der pfändbare Betrag errechnet sich folgendermaßen:",
              noIncome: "Es ist kein Einkommen gegeben, weshalb auch keine Pfändung berechnet werden kann.",
              singleStream14:
                "Bei einem Monatseinkommen von {{income}} (Anspruch auf Sonderzahlungen) und {{count}} Unterhaltspflichten sind {{seizable}} pfändbar.",
              singleStream12:
                "Bei einem Monatseinkommen von {{income}} (kein Anspruch auf Sonderzahlungen) und {{count}} Unterhaltspflichten sind {{seizable}} pfändbar.",
              streamSeizable:
                "Vom Monatseinkommen von {{income}}, das {{times}} mal jährlich ausbezahlt wird, sind {{seizable}} pfändbar.",
              streamSeizableWithPercentage:
                "Vom Monatseinkommen von {{income}}, das {{times}} mal jährlich ausbezahlt wird, sind {{seizable}} (d.s. {{percentage}}) pfändbar.",
              streamFullyProtected:
                "Das Monatseinkommen von {{income}}, das {{times}} mal jährlich ausbezahlt wird, ist zur Gänze unpfändbar, da es geringer als der Grundbetrag von {{base}} ist.",
              otherStreamAlsoProtected:
                "Das Monatseinkommen von {{income}}, das {{times}} mal jährlich ausbezahlt wird, ist ebenfalls zur Gänze unpfändbar, da nicht einmal die Summe aus beiden Monatseinkommen (d.s. {{combined}}) den Grundbetrag von {{base}} erreicht.",
              otherStreamSeizableAfterDifference:
                "Vom Monatseinkommen von {{income}}, das {{times}} mal jährlich ausbezahlt wird, sind {{seizable}} pfändbar. Das entspricht {{percentage}} des Monatseinkommens von {{income}} abzüglich des Differenzbetrages in der Höhe von {{difference}} zwischen dem anderen Einkommen ({{otherIncome}}) und dem Grundbetrag ({{base}}).",
              aliquotSplit:
                "Die Pfändung wurde nach der „Aliquotierungsvariante“ nach EO §292 Abs 3a berechnet, wobei die Grundbeträge im Verhältnis von {{share12}} für {{income12}} und {{share14}} für {{income14}} aufgeteilt wurden.",
              aliquotStreamProtected:
                "Das Monatseinkommen von {{income}}, das {{times}} mal jährlich ausbezahlt wird, ist zur Gänze unpfändbar, da es geringer als der anteilsmäßige Grundbetrag ({{share}} von {{subsistence}}) von {{base}} ist.",
              aliquotFullyProtected:
                "Die Pfändung wurde nach der „Aliquotierungsvariante“ nach EO §292 Abs 3a berechnet, wobei bei Aufteilung der Grundbeträge bei beiden Bezügen der jeweilige anteilige Grundbetrag zu überschreiten ist. Dies ist bei diesen geringen Einkommen ({{income12}} + {{income14}}) nicht möglich, weshalb auch bei Zusammenrechnung der Bezüge nach der Aliquotierungsmethode das gesamte Einkommen pfändungsfrei zu stellen ist.",
              maintenanceObligations_one: "Es wurde {{count}} Unterhaltspflicht berücksichtigt.",
              maintenanceObligations_other: "Es wurden {{count}} Unterhaltspflichten berücksichtigt.",
            },
          },
          list: {
            title: "Liste der Einkommen",
            notice:
              "Hier ist jedes Einkommen anzugeben. Nicht anzugeben sind alle Arten von Beihilfen und Zuschüssen, Alimente und Pflegegeld. Kinderbetreuungsgeld (= Karenzgeld) oder Mindestsicherung (= Sozialhilfe) ist nur dann anzugeben, wenn Sie sonst kein anderes Einkommen haben.",
            spousalMaintenanceNotice:
              "Wenn Sie kein eigenes oder nur ein geringes Einkommen haben, aber verheiratet sind, so haben Sie einen gesetzlichen Unterhaltsanspruch gegenüber Ihrem:Ihrer Ehepartner:in. Wie hoch dieser Unterhaltsanspruch ist, können Sie <calcLink>hier berechnen</calcLink>.",
            add: "ein weiteres Einkommen angeben",
          },
          entry: {
            title: "{{number}}. Einkommen",
            remove: "löschen",
            payerNameAndAddress: "Name und komplette Adresse der bezugsauszahlenden Stelle",
            incomeType: "Einkommensart",
            hasSpecialPayments:
              "Besteht ein Anspruch auf Sonderzahlungen (Sonderzahlungen sind z.B. Weihnachts- oder Urlaubsgeld)",
            hasSpecialPaymentsInfo:
              "Diese Frage ist z.B. dann mit „Ja“ zu beantworten, wenn Sie im Laufe des Jahres Urlaubs- oder ein Weihnachtsgeld bekommen. Mit „Nein“ ist diese Frage dann zu beantworten, wenn es sich bei dem Einkommen z.B. um Arbeitslosengeld, Notstandshilfe oder Kinderbetreuungsgeld handelt.",
            specialPaymentsPlausibility: "Überprüfen Sie bitte, ob Sie nicht doch Sonderzahlungen bekommen",
            dailyRate: "Tagsatz",
            fillFromDailyRate: "Sollen die Monatsbeträge aufgrund des angegebenen Tagsatzes eingetragen werden?",
            fillFromDailyRateInfo:
              "Wird hier „Ja“ gewählt, so werden die Auszahlungsbeträge jener Monate, die angegeben sind, mit dem Produkt aus Tagsatz und Anzahl der Tage des entsprechenden Monates überschrieben. Ist kein gültiger Tagsatz angegeben oder sind keine Monate ausgewählt, passiert nichts.",
            specialPaymentCount: "Auf wieviel Sonderzahlungen im Jahr haben Sie Anspruch?",
            specialPaymentCountOptions: {
              one: "1 Sonderzahlung",
              two: "2 Sonderzahlungen (Weihnachtsremuneration und Urlaubsgeld)",
              threeOrMore: "3 oder mehr Sonderzahlungen",
            },
            note: "Anmerkungen zu diesem Einkommen:",
            answerFollowUpsWithNo: "Die nächsten 6 Fragen alle mit „Nein“ beantworten",
            isPartiallyGarnished: "Wird dieses Einkommen zum Teil gepfändet?",
            hasEmployerFamilyAllowance:
              "Zahlt Ihnen Ihr Dienstgeber eine Familienbeihilfe, einen Kinderabsetzbetrag o.ä. aus?",
            hasEmployerSettledExpenses:
              "Werden persönliche Ausgaben (z.B. Essensmarken etc.) direkt vom Dienstgeber abgerechnet?",
            hasEmployerSettledExpensesInfo:
              "Hier ist die Summe all jener Abzüge anzugeben, die persönliche Ausgaben darstellen. Darunter fallen insbesondere: Gewerkschaftsbeitrag, Essensmarken, Prämien für eine freiwillige Pensionsvorsorge- bzw. Lebensversicherung und Prämien für andere freiwillige Versicherungen wie Kranken- oder Unfallversicherung. Diese Aufzählung erhebt keinen Anspruch auf Vollständigkeit.",
            hasBenefitInKind: "Beziehen Sie eine Naturalleistung (Dienstwohnung, Dienstauto für private Zwecke etc.)?",
            benefitInKindAmount: "Wie hoch ist der Wert des Naturalbezuges?",
            receivesTips: "Bekommen Sie Trinkgelder?",
            monthlyTipAmount: "Wieviel Trinkgeld bekommen Sie durchschnittlich monatlich?",
            hasExpenseAllowances:
              "Sind in Ihren Bezügen „wirkliche“ Aufwandsentschädigungen (z.B. Taggelder, Diäten etc.) enthalten?",
          },
          months: {
            title: "Einkommen der letzten 3 Monate",
            month: "Monat",
            monthColumn: "Monat {{number}}",
            paidAmount: "Auszahlungsbetrag",
            garnishedAmount: "einbehaltene Lohnpfändung",
            expenseAllowance: "Höhe der „wirklichen“ Aufwandsentschädigung (z.B. Taggelder, Diäten etc.)",
            familyAllowance: "Höhe der vom Dienstgeber ausbezahlten Familienbeihilfe incl. des Kinderabsetzbetrages",
            employerSettledExpenses: "Höhe der vom Dienstgeber abgerechneten eigenen Ausgaben (z.B. Essensmarken)",
            specialPaymentPaid: "Wurde in diesem Monat eine Sonderzahlung ausbezahlt?",
            relevantMonthlyIncome: "für Pfändung relevantes Monatseinkommen",
            monthlyIncome: "Monatseinkommen",
          },
          average: {
            relevantAverageIncome: "für Pfändung relevantes Durchschnittseinkommen",
            averageIncome: "Durchschnittseinkommen",
            basisAll: "(Durchschnitt der angegebenen 3 Monate)",
            basisSome: "(Durchschnitt der Monate {{months}})",
            basisOne: "(Einkommen des Monates {{month}})",
            and: "und",
            isRepresentative:
              "Ist das Durchschnittseinkommen der angegebenen 3 Monate charakteristisch (typisch, repräsentativ) für Ihr Einkommen?",
            nonRepresentativeReason:
              "Warum ist das angegebene Durchschnittseinkommen nicht charakteristisch (typisch, repräsentativ) für Ihr Einkommen?",
            actualAverageIncome: "Wie hoch ist Ihr monatliches Durchschnittseinkommen wirklich?",
          },
          proofs: {
            title: "Einkommensbelege",
            uploadHint: "Einkommensbelege wie Lohnzettel, Mitteilung des AMS etc. hochladen oder hierher ziehen",
          },
        },
        expensesTab: {
          saveSuccess: "Ausgaben erfolgreich gespeichert",
          validation: {
            livingCostsMinimum: "Betrag muss zumindest 200,00 € betragen",
            amountBelowShare: "Der angegebene Gesamtbetrag ist kleiner als der Anteil des Schuldners",
          },
          generalQuestions: {
            title: "Allgemeine Fragen",
            hasIllnessExtraCosts: "Haben Sie Mehrauslagen wegen Krankheit (Diätkosten)?",
            hasIllnessExtraCostsInfo:
              "Wenn Sie regelmäßige Ausgaben wegen einer Krankheit haben, so geben Sie hier bitte „Ja“ an.",
            proofRequired: "Wichtig: Sie müssen die Mehrauslagen belegen können.",
            illnessExtraCostAmount:
              "Wie hoch sind die monatlichen Mehrauslagen aufgrund von Krankheit bzw. Diätkosten?",
          },
          obligations: {
            title: "Regelmäßig wiederkehrende Verpflichtungen (laufende Ausgaben für Wohnung etc.)",
            paysCostsAlone: "Tragen Sie die laufenden Kosten alleine?",
            paysCostsAloneInfo: "Wenn sich jemand z.B. an der Miete beteiligt, so geben Sie hier bitte „Nein“ an.",
            costSharingExplanation: "Erklären Sie bitte mit wem Sie sich die Kosten teilen",
            hintMonthlyAmounts:
              "Bitte geben Sie die <bold>genauen</bold> (= „auf den Cent genauen“) <bold>Monatsbeträge</bold> an. Sollten Sie z.B. Strom/Gas nur alle 3 Monate bezahlen müssen, so teilen Sie bitte den Betrag, den sie alle 3 Monate bezahlen müssen, durch 3.",
            hintProofs:
              "Sie müssen die entsprechenden Belege im Fall eines Privatkonkurses dem Gericht vorlegen. Halten Sie also die Belege über die angegeben Ausgaben bereit.",
            hintNoProofsTitle: "Nicht belegt werden müssen:",
            hintNoProofsItems:
              "Ausgaben für ein Wertkartenhandy · Ausgaben für Fahrscheine für die öffentlichen Verkehrsmittel · Ausgaben für den Lebensunterhalt",
            remarks: "Bemerkungen:",
            remarksInfo:
              "Hier können Bemerkungen gemacht werden. Z.B. sollte bei Inanspruchnahme einer Wohn- bzw. Mietbeihilfe dieser Umstand angeführt werden. Bei den Ausgaben ist dann nur die Miete nach Abzug der Wohn- bzw. Mietbeihilfe anzugeben.",
          },
          table: {
            caption: "Regelmäßig wiederkehrende Verpflichtungen",
            position: "Ausgabe",
            amount: "Betrag",
            debtorShare: "Anteil des Schuldners",
            amountOf: "{{position}} – Betrag",
            debtorShareOf: "{{position}} – Anteil des Schuldners",
            maintenance_one: "Unterhaltsverpflichtungen in Geld für {{count}} Person",
            maintenance_other: "Unterhaltsverpflichtungen in Geld für {{count}} Personen",
            maintenanceInfo:
              "Die Angaben über die Unterhaltsverpflichtungen können nur unter dem Punkt „Angehörige“ im Vermögensverzeichnis geändert werden. Hier gemachte Änderungen werden nicht übernommen.",
            total: "Gesamt",
          },
          positions: {
            Rent: "Miete (inkl. Betriebskosten)",
            HomeOwnership: "Eigenheim (z.B Kanalgebühr, Müllabfuhr, Steuern und Abgaben)",
            Energy: "Strom/Gas",
            Heating: "Heizung",
            Phone: "Telefon",
            Broadcasting: "ORF, Kabelfernsehen",
            Childcare: "Kindergarten/Hort/Schule",
            PublicTransport: "Öffentl. Verkehrsmittel (Netzkarte)",
            HouseholdInsurance: "Haushaltsversicherung",
            LifeInsurance: "Lebensversicherung",
            OtherInsurance: "Sonstige Versicherungen",
            Vehicles: "Kraftfahrzeuge",
            VehicleInsuranceAndTax: "KFZ-Versicherung und Steuer",
            Fuel: "Treibstoff",
            Parking: "Autoabstellplatz (Miete)",
            LivingCosts: "Lebensunterhalt (zB Essen, Kleidung, Haushalt, Zigaretten, Freizeit, Bildung, Kultur)",
            Other: "Sonstiges",
          },
          positionInfo: {
            Rent: "Wenn Sie Wohn- bzw. Mietbeihilfe bekommen, so geben Sie hier bitte die Miete nach Abzug der Wohn- bzw. Mietbeihilfe an und weisen Sie in den Bemerkungen darauf hin, dass Sie Wohn- bzw. Mietbeihilfe bekommen.",
            Phone: "Wenn Sie ein Wertkartenhandy verwenden, weisen Sie bitte in den Bemerkungen darauf hin",
            LivingCosts:
              "Es wird davon ausgegangen, dass zumindest ein Betrag von 200,00 € monatlich für den Lebensunterhalt (Essen, Kleidung, Hygiene etc.) zur Verfügung stehen müssen.",
            Other:
              "Sollten Sie „sonstige Ausgaben“ haben, so erklären Sie bitte in den Bemerkungen, worum es sich dabei handelt",
          },
          summary: {
            totalIncome: "Gesamteinkommen (davon {{seizable}} pfändbar)",
            totalExpenses: "- Gesamtausgaben",
            remaining: "verbleiben:",
            expensesExceedIncome: "Ihre Ausgaben übersteigen Ihr Einkommen! Überprüfen Sie bitte Ihre Eigaben.",
          },
          partner: {
            label: "Partner",
            info: "Hier kann eine EDV-Nr eingeben werden. Wird einE KlientIn zu der eingebenen EDV-Nr gefunden, so wird der/die KlientIn angezeigt und es können die Wohnungskosten geteilt werden.",
            search: "Suchen",
            sharedWith: "Ausgaben mit {{name}}",
            share: "jetzt teilen",
            saveFirst: "Bitte speichern Sie die Ausgaben, bevor Sie sie teilen.",
            confirmTitle: "Ausgaben teilen",
            confirmText:
              "Es werden alle eingetragenen Ausgaben bei {{name}} gelöscht und die sich hier ergebenden Differnzbeträge als Ausgaben eingetragen. Wollen Sie fortsetzen?",
            shareSuccess: "Die Ausgaben wurden mit {{name}} geteilt",
            notFound: "Zu dieser EDV-Nr wurde keinE KlientIn gefunden.",
            isSelf: "Die Ausgaben können nicht mit dem:der KlientIn selbst geteilt werden.",
            searchFailed: "Die Suche ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
          },
          proofs: {
            title: "Belege",
            uploadHint: "Belege der Ausgaben hochladen oder hierher ziehen",
          },
        },
        ownClaimsTab: {
          saveSuccess: "Forderungen erfolgreich gespeichert",
          entry: {
            title: "Forderungen",
            infoOwed:
              "Hier sind all jene Forderungen einzutragen, die Sie gegenüber anderen haben. Wenn Ihnen also jemand Geld schuldet, tragen Sie das hier ein.",
            infoPending:
              "Auch Forderungen von Ihnen, die noch bei Gericht anhängig sind (z.B. ein Prozess wegen ausständigem Lohn gegen einen ehemaligen Dienstgeber), sind hier anzugeben.",
            hasOwnClaims: "Schuldet Ihnen jemand Geld bzw. haben Sie Ansprüche gegen jemand anderen?",
          },
          list: {
            title: "Übersicht der Forderungen",
            intro: "Geben Sie hier die Forderungen an.",
            empty: "Es ist noch keine Forderung erfasst.",
            debtor: "Schuldnerin/Schuldner",
            legalReason: "Rechtsgrund",
            amountAndDueDate: "Höhe der Forderung / Fälligkeit",
            securities: "Sicherheiten",
            disputed: "Streitig?",
            collectible: "Einbringlich?",
            claim: "{{number}}. Forderung",
            addFirst: "eine Forderung angeben",
            addFurther: "eine weitere Forderung angeben",
            notRelated: "nicht verwandt",
            noSecurities: "keine",
            notDisputed: "Nein",
            isCollectible: "Ja",
          },
          detail: {
            title: "Fragen zur {{number}}. Forderung beantworten",
            debtorName: "Name des Schuldners",
            debtorAddress: "Anschrift des Schuldners",
            isRelated: "Ist der Schuldner mit Ihnen verwandt?",
            relationship: "Verwandtschaftsverhältnis",
            legalReason: "Rechtsgrund (zB Darlehen, Verkauf usw.)",
            amount: "Höhe der Forderung",
            dueDate: "Fälligkeitsdatum",
            isSecured: "Ist diese Forderung besichert, gibt es Sicherheiten?",
            securities: "Sicherheiten (vertr., gerichtl. Pfandrechte, Zession)",
            isDisputed: "Ist diese Forderung streitig?",
            hasPendingCourtProceedings: "Ist ein Gerichtsverfahren anhängig?",
            courtProceedingDetails: "Angaben zum Gerichtsverfahren (Gericht, Aktenzahl usw.)",
            disputeDetails: "nähere Angaben zur Streitigkeit",
            isCollectible: "Ist diese Forderung einbringlich?",
            collectionSteps: "Welche Schritte wurden zur Einbringlichmachung gesetzt?",
            apply: "Übernehmen",
            deleteConfirmTitle: "Forderung löschen",
            deleteConfirmText: "Wollen Sie die {{number}}. Forderung wirklich löschen?",
          },
          documents: {
            title: "Unterlagen zu den eigenen Forderungen",
            uploadHint: "Unterlagen zu den eigenen Forderungen hochladen oder hierher ziehen",
          },
        },
        assetsTab: {
          saveSuccess: "Vermögen erfolgreich gespeichert",
          pleaseSelect: "bitte auswählen",
          deleteEntryConfirmTitle: "Eintrag löschen",
          deleteEntryConfirm: "Wollen Sie diesen Eintrag wirklich löschen?",
          realEstate: {
            title: "Grundstücke und Rechte an unbeweglichen Sachen",
            hasDomesticRealEstate:
              "Haben Sie ein Grundstück, eine Eigentumswohnung, ein Haus oder ein Baurecht in Österreich?",
            domesticRealEstateDetails: "Angaben zum Grundstück, Eigentumswohnung, Haus oder Baurecht:",
            domesticUpload: "Unterlagen zur Immobilie hochladen oder hierher ziehen",
            hasForeignRealEstate: "Haben Sie ein Grundstück oder ein Haus im Ausland?",
            foreignRealEstateDetails: "Angaben zum Grundstück, Eigentumswohnung, Haus oder Baurecht:",
            foreignUpload: "Unterlagen zur Immobilie im Ausland hochladen oder hierher ziehen",
          },
          holding: {
            selection: "zur Auswahl:",
            street: "Adresse: Straße",
            houseNumber: "Adresse: Hausnummer",
            zipCode: "Adresse: PLZ",
            city: "Adresse: Ort",
            country: "Adresse: Land",
            encumbranceYes: "Ja",
            encumbranceNo: "Nein",
            encumbranceUnknown: "Weiß nicht",
            encumbranceWarning: "Klärung, ob vinkuliert, abgetreten oder verpfändet wurde",
            claimLabel: "{{creditor}}, Zahl: {{caseNumber}}",
            claimRemoved: "Gläubiger erledigt oder gelöscht",
            usedForProceedingCosts:
              "Wurde dieses Sparbuch/-konto zur Ansparung eines die voraussichtlichen Kosten eines Schuldenregulierungsverfahrens deckenden Vermögens verwendet?",
            value: "Höhe des aktuellen Wertes",
            valueDate: "per Stichtagsdatum",
            valueWarning: "Wert muss noch erfragt und nachgetragen werden",
            remarks: "weitere Angaben",
          },
          holdings: {
            buildingSavingsContracts: {
              title: "Bausparverträge",
              entryQuestion: "Haben Sie einen oder mehrere Bausparverträge?",
              blockTitle: "Bausparvertrag {{number}}",
              institution: "Bei welcher Bank haben Sie den Bausparvertrag?",
              institutionFurther: "Bei welcher Bank haben Sie den weiteren Bausparvertrag?",
              accountNumber: "Kontonummer des Bausparvertrages:",
              accountNumberFurther: "Kontonummer des weiteren Bausparvertrages:",
              encumbrance: "Wurde dieser Bausparvertrag vinkuliert, abgetreten oder verpfändet?",
              encumbranceInfo:
                "Ob dieser Bausparvertrag vinkuliert, abgetreten oder verpfändet ist, erfahren Sie direkt bei Ihrer Bausparkasse oder der Bank, bei der Sie den Bausparvertrag abgeschlossen haben.",
              encumberedClaim: "An wen wurde dieser Bausparvertrag abgetreten, verpfändet oder vinkuliert?",
              isValueKnown: "Ist Ihnen der genaue aktuelle Wert dieses Bausparvertrages bekannt?",
              valueUnknownInfo:
                "Wenn Sie den aktuellen Wert dieses Bausparvertrages nicht wissen, so erfahren Sie ihn direkt bei der Bausparkasse oder der Bank, wo Sie den Bausparvertrag abgeschlossen haben.",
              add: "einen weiteren Bausparvertrag angeben",
              remove: "Bausparvertrag entfernen",
              upload: "Schreiben der Bausparkasse hochladen oder hierher ziehen",
            },
            savingsAccounts: {
              title: "Sparbücher / Sparkonten",
              entryQuestion: "Haben Sie ein oder mehrere Sparbücher/-konten?",
              blockTitle: "Sparbuch/-konto {{number}}",
              institution: "Bei welcher Bank haben Sie das Sparbuch/-konto?",
              institutionFurther: "Bei welcher Bank haben Sie das weitere Sparbuch/-konto?",
              accountNumber: "Kontonummer des Sparbuches/-kontos:",
              accountNumberFurther: "Kontonummer des weiteren Sparbuches/-kontos:",
              encumbrance: "Wurde dieses Sparbuch/-konto vinkuliert, abgetreten oder verpfändet?",
              encumbranceInfo:
                "Ob dieses Sparbuch vinkuliert, abgetreten oder verpfändet ist, erfahren Sie direkt bei Ihrer Bank.",
              encumberedClaim: "An wen wurde dieses Sparbuch/-konto abgetreten, verpfändet oder vinkuliert?",
              isValueKnown: "Ist Ihnen der genaue aktuelle Wert dieses Sparbuches/-kontos bekannt?",
              valueUnknownInfo:
                "Wenn Sie den aktuellen Wert dieses Sparbuches nicht wissen, so erfahren Sie ihn direkt bei der Bank.",
              add: "ein weiteres Sparbuch/-konto angeben",
              remove: "Sparbuch/-konto entfernen",
              upload: "Sparbuch oder Auszug Sparkonto hochladen oder hierher ziehen",
            },
            lifeInsurances: {
              title: "Lebensversicherungen",
              entryQuestion: "Haben Sie eine oder mehrere Lebensversicherungen?",
              blockTitle: "Lebensversicherung {{number}}",
              institution: "Bei welcher Versicherung haben Sie die Lebensversicherung?",
              institutionFurther: "Bei welcher Versicherung haben Sie die weitere Lebensversicherung?",
              accountNumber: "Polizzennummer der Lebensversicherung:",
              accountNumberFurther: "Polizzennummer der weiteren Lebensversicherung:",
              encumbrance: "Wurde diese Lebensversicherung vinkuliert, abgetreten oder verpfändet?",
              encumbranceInfo:
                "Ob diese Lebensversicherung vinkuliert, abgetreten oder verpfändet ist, erfahren Sie direkt bei der Versicherung.",
              encumberedClaim: "An wen wurde diese Lebensversicherung abgetreten, verpfändet oder vinkuliert?",
              isValueKnown: "Ist Ihnen der genaue aktuelle Wert dieser Lebensversicherung bekannt?",
              valueUnknownInfo:
                "Wenn Sie den aktuellen Rückkaufswert dieser Versicherung nicht kennen, so erfragen Sie ihn bitte direkt bei der Versicherung.",
              add: "eine weitere Lebensversicherung angeben",
              remove: "Lebensversicherung entfernen",
              upload: "Schreiben der Versicherung hochladen oder hierher ziehen",
            },
            pensionInsurances: {
              title: "Pensionsvorsorgeversicherungen",
              entryQuestion: "Haben Sie eine oder mehrere Pensionsvorsorgeversicherungen?",
              blockTitle: "Pensionsvorsorge {{number}}",
              institution: "Bei welcher Versicherung haben Sie die Pensionsvorsorgeversicherung?",
              institutionFurther: "Bei welcher Versicherung haben Sie die weitere Pensionsvorsorgeversicherung?",
              accountNumber: "Polizzennummer der Pensionsvorsorgeversicherung:",
              accountNumberFurther: "Polizzennummer der weiteren Pensionsvorsorgeversicherung:",
              encumbrance: "Wurde diese Pensionsvorsorgeversicherung vinkuliert, abgetreten oder verpfändet?",
              encumbranceInfo:
                "Ob diese Pensionsvorsorgeversicherung vinkuliert, abgetreten oder verpfändet ist, erfahren Sie direkt bei der Versicherung.",
              encumberedClaim:
                "An wen wurde diese Pensionsvorsorgeversicherung abgetreten, verpfändet oder vinkuliert?",
              isValueKnown: "Ist Ihnen der genaue aktuelle Wert dieser Pensionsvorsorgeversicherung bekannt?",
              valueUnknownInfo:
                "Wenn Ihnen der aktuelle Rückkaufswert dieser Versicherung nicht bekannt ist, so erfahren Sie ihn direkt bei der Versicherung.",
              add: "eine weitere Pensionsvorsorgeversicherung angeben",
              remove: "Pensionsvorsorgeversicherung entfernen",
              upload: "Nachweis über Pensionsvorsorge hochladen oder hierher ziehen",
            },
            securitiesDepots: {
              title: "Wertpapierdepots",
              entryQuestion: "Haben Sie ein oder mehrere Wertpapierdepots?",
              blockTitle: "Wertpapierdepot {{number}}",
              institution: "Bei welcher Bank haben Sie das Wertpapierdepot?",
              institutionFurther: "Bei welcher Bank haben Sie das weitere Wertpapierdepot?",
              accountNumber: "Kontonummern des Wertpapierdepots:",
              accountNumberFurther: "Kontonummern des weiteren Wertpapierdepots:",
              encumbrance: "Wurde dieses Wertpapierdepot vinkuliert, abgetreten oder verpfändet?",
              encumbranceInfo:
                "Ob die Wertpapiere vinkuliert, abgetreten oder verpfändet sind, erfahren Sie direkt bei der Bank, die das Wertpapierdepot verwaltet.",
              encumberedClaim: "An wen wurde dieses Wertpapierdepot abgetreten, verpfändet oder vinkuliert?",
              isValueKnown: "Ist Ihnen der genaue aktuelle Wert dieses Wertpapierdepots bekannt?",
              valueUnknownInfo:
                "Wenn Ihnen der aktuelle Rückkaufswert dieses Wertpapierdepots nicht bekannt ist, so erfahren Sie ihn direkt bei der Bank, die das Depot verwaltet.",
              add: "ein weiteres Wertpapierdepot angeben",
              remove: "Wertpapierdepot entfernen",
              upload: "Nachweis über Wertpapier(e) hochladen oder hierher ziehen",
            },
          },
          cash: {
            title: "Sonstiges Bar- oder Bankvermögen",
            hasSafeDeposit: "Haben Sie einen Safe oder ein Bankschließfach gemietet?",
            safeDepositDetails:
              "Bei welcher Bank haben Sie das Bankschließfach? Was beinhaltet das Bankschließfach? Sollten Sie mehrere Bankschließfächer haben, so geben Sie bitte alle Bankschließfächer an.",
            hasOtherCashAssets: "Haben Sie sonstiges Bar- oder Bankvermögen?",
            isSavedForProceeding: "Haben Sie den angesparten Betrag für den Privatkonkurs angespart?",
            savedForProceedingAmount: "Höhe des angesparten Betrages",
            savedForProceedingDate: "per Stichtagsdatum",
            otherCashAssetsDetails: "Angaben zu dem sonstigen Bar- und/oder Bankvermögen",
            upload: "Unterlagen zum Bankvermögen hochladen oder hierher ziehen",
          },
          movables: {
            title: "Bewegliche Sachen",
            hasValuables: "Haben Sie Schmuck oder sonstige Wertsachen?",
            valuablesDetails: "Welche Schmuckstücke bzw. Wertsachen haben Sie? Wie hoch schätzen Sie deren Wert ein?",
            hasFurnishings: "Haben Sie Einrichtungsgegenstände?",
            furnishingsDetails: "Welche Einrichtungsgegenstände haben Sie?",
            furnishingsInfo:
              "Sollten Ihre Einrichtungsgegenstände einem bescheidenen Lebensstil entsprechen, so können Sie das auch so angeben: „Die Einrichtungsgegenstände entsprechen einem bescheidenen Lebensstil.“",
            hasAppliances: "Haben Sie Elektro- oder Haushaltsgeräte (z.B. Fernseher, Mikrowelle etc.)?",
            appliancesDetails: "Welche Elektro- und Haushaltsgeräte haben Sie? Zählen Sie bitte alle auf.",
            appliancesInfo:
              "Geben Sie hier bitte alle Elektro- und Haushaltsgeräte an. z.B.: Kühlschrank, Tiefkühlgerät, Waschmaschine, Wäschetrockner, Geschirrspüler, Mikrowelle, TV, Video, DVD-Player, Blu-Ray Player, Spielkonsolen, …",
            hasEquipment:
              "Haben Sie Gebrauchsgegenstände wie z.B. Fotoapparate, Sportgeräte, Musikinstrumente, Computer u.ä.?",
            equipmentDetails: "Welche Gebrauchsgegenstände haben Sie? Zählen Sie bitte alle auf.",
            equipmentInfo:
              "Geben Sie hier bitte alle Gebrauchsgegenstände an. z.B.: Fotoapparate, Sportgeräte, Musikinstrumente, Computer, Laptop, …",
            hasVehicles: "Haben Sie ein Kraftfahrzeug (Auto, Fahrräder, Boote u.ä.)?",
            vehiclesDetails: "Welche Kraftfahrzeuge (Art, Modell, Typ, Baujahr etc.) haben Sie?",
            vehiclesUpload:
              "Unterlagen zum Fahrzeug (Typenschein, Kaufvertrag, Zulassung) hochladen oder hierher ziehen",
            hasBuildingsOnForeignLand:
              "Haben Sie Bauten auf fremden Grundstücken, insb. Häuser, Schrebergartenhütten und Kioske?",
            buildingsOnForeignLandDetails:
              "Welche Bauten auf fremden Grundstücken (Häuser, Schrebergartenhütten, Kioske etc.) haben Sie?",
            buildingsOnForeignLandUpload: "Unterlagen zu Bauten auf fremden Grundstücken hochladen oder hierher ziehen",
            hasOtherItems: "Haben Sie sonstige Sachen?",
            otherItemsDetails: "Welche sonstigen Sachen haben Sie?",
            ownsAllItems: "Gehören alle oben angeführten Sachen Ihnen persönlich?",
            itemsOwnedByOthersDetails:
              "Welche der oben angeführten Sachen gehören nicht Ihnen? Geben Sie an, um welche Sachen es sich handelt und wem Sie gehören.",
          },
        },
        propertyRightsTab: {
          title: "Andere Vermögensrechte",
          saveSuccess: "Andere Vermögensrechte erfolgreich gespeichert",
          pleaseSelect: "bitte auswählen",
          removeConfirmTitle: "Eintrag löschen",
          removeConfirm: "Wollen Sie diesen Eintrag wirklich löschen?",
          letter: "Sie können dazu diesen Brief verwenden.",
          tenancy: {
            entryQuestion: "Haben Sie Mietrechte (zB. an einer Mietwohnung, Genossenschaftswohnung, einem Büro u.ä.)?",
            entryInfo:
              "Ein Mietrecht haben Sie dann, wenn Sie Mieter (einer Mietwohnung, Gemeindewohnung, Genossenschaftswohnung …) sind und auch einen Mietvertrag haben.",
            tenantOrOwner:
              "Wer ist der Mieter bzw. Eigentümer der Adresse {{address}}, die Sie als Ihre Wohnadresse angegeben haben?",
            tenantOrOwnerLabel: "Mieter bzw. Eigentümer der Wohnadresse",
            blockTitle: "Mietrecht {{number}}",
            landlord: "Wer ist der Vermieter bei diesem Mietrecht?",
            landlordFurther: "Wer ist der Vermieter bei diesem weiteren Mietrecht?",
            isCurrentHome: "Handelt es sich bei diesem Mietrecht um Ihre Wohnung, die Sie aktuell bewohnen?",
            isCurrentHomeFurther:
              "Handelt es sich bei diesem weiteren Mietrecht um Ihre Wohnung, die Sie aktuell bewohnen?",
            propertyDetails: "Machen Sie bitte nähere Angaben zu diesem Mietobjekt",
            expectsProceeds: "Wäre bei Auszug aus diesem Mietobjekt mit einem Erlös zu rechnen?",
            expectsProceedsFurther: "Wäre bei Auszug aus diesem weiteren Mietobjekt mit einem Erlös zu rechnen?",
            expectsProceedsInfo:
              "Wenn Sie beim Auszug aus der Wohnung einen Genossenschaftsanteil, eine Ablöse oder einen anderen Finanzierungsbeitrag erhalten, wählen Sie „Ja“. Wenn Sie nur die Kaution zurückbekommen, wählen Sie „Nein“.",
            proceedsEncumbrance: "Ist der zu erwartende Erlös bereits verpfändet?",
            encumbranceYes: "Ja",
            encumbranceNo: "Nein",
            encumbranceUnknown: "Weiß nicht",
            encumbranceWarning: "Klärung, ob Erlös bei Aufgabe des Mietrechtes verpfändet ist",
            encumbranceHint:
              "Ob der zu erwartende Erlös bereits verpfändet ist, erfahren Sie direkt bei Ihrem Vermieter.",
            encumberedClaim: "Welcher Gläubiger hat das Pfandrecht am zu erwartenden Erlös?",
            isAmountKnown: "Ist Ihnen bekannt, wie hoch der Erlös bei Aufgabe des Mietrechtes (=Auszuges) wäre?",
            amountWarning: "Höhe des Erlöses bei Aufgabe des Mietrechtes muss noch erfragt und nachgetragen werden",
            amountHint: "Wie hoch der zu erwartende Erlös wäre, erfahren Sie direkt bei Ihrem Vermieter.",
            amount: "Höhe des Erlöses bei Aufgabe des Mietrechtes",
            amountDate: "per Stichtagsdatum",
            remarks: "Zusätzliche Bemerkungen",
            add: "ein weiteres Mietrecht angeben",
            remove: "Mietrecht {{number}} entfernen",
            upload: "Mietvertrag und evtl. weitere Unterlagen zur Miete hochladen oder hierher ziehen",
          },
          companyShares: {
            entryQuestion: "Sind Sie an einer Gesellschaft (GmbH, KG etc.) beteiligt?",
            blockTitle: "Beteiligung {{number}}",
            details: "Machen Sie bitte nähere Angaben zu der Beteiligung.",
            detailsFurther: "Machen Sie bitte nähere Angaben zu der weiteren Beteiligung.",
            detailsInfo:
              "Geben Sie hier bitte an, um welche Gesellschaft und welche Gesellschaftsform (GmbH, KG, OHG etc.) es sich hier handelt, wie hoch Ihre Beteiligung, deren Wert und Verwertbarkeit ist.",
            add: "eine weitere Beteiligung angeben",
            remove: "Beteiligung {{number}} entfernen",
            upload: "Unterlagen zu Firmenbeteiligungen hochladen oder hierher ziehen",
          },
          cooperativeMemberships: {
            entryQuestion: "Sind Sie Mitglied einer Genossenschaft?",
            entryInfo:
              "Eine Mitgliedschaft bei einer Wohnungsgenossenschaft geben Sie bitte unter „Mietrechte“ an. Geben Sie hier bitte an, um welche Genossenschaft es sich handelt und wie hoch Ihr Genossenschaftsanteil ist.",
            blockTitle: "Mitgliedschaft {{number}}",
            details: "Machen Sie bitte nähere Angaben zu der Mitgliedschaft an der Genossenschaft.",
            detailsFurther: "Machen Sie bitte nähere Angaben zu der Mitgliedschaft an der weiteren Genossenschaft.",
            add: "eine weitere Mitgliedschaft angeben",
            remove: "Mitgliedschaft {{number}} entfernen",
            upload: "Unterlagen zur Mitgliedschaft bei der Genossenschaft hochladen oder hierher ziehen",
          },
          otherRights: {
            entryQuestion: "Gibt es sonstige Vermögensrechte?",
            blockTitle: "Vermögensrecht {{number}}",
            details: "Machen Sie bitte nähere Angaben zu diesem sonstigen Vermögensrecht.",
            detailsFurther: "Machen Sie bitte nähere Angaben zu diesem weiteren sonstigen Vermögensrecht.",
            add: "ein weiteres sonstiges Vermögensrecht angeben",
            remove: "Vermögensrecht {{number}} entfernen",
            upload: "Unterlagen zu den sonstigen Vermögensrechten hochladen oder hierher ziehen",
          },
        },
        donationsTab: {
          title: "Schenkungen, Vermögensauseinandersetzung",
          saveSuccess: "Schenkungen erfolgreich gespeichert",
          period: "Die 10 Jahre werden vom möglichen Konkurseröffnungsdatum zurückgerechnet.",
          upload: "Unterlagen zu den Vermögensauseinandersetzungen hochladen oder hierher ziehen",
          detailsLabel: "In welchem Verwandtschaftsverhältnis stehen Sie zu diesen?",
          gratuitousDispositions: {
            question:
              "Haben Sie innerhalb der letzten 10 Jahre unentgeltliche Verfügungen (etwa Schenkungen) zugunsten Angehöriger getroffen?",
            questionRequired:
              "Bitte geben Sie an, ob Sie in den letzten 10 Jahren unentgeltliche Verfügungen zugunsten Angehöriger getroffen haben.",
            details:
              "Welche unentgeltlichen Verfügungen (etwa Schenkungen) haben Sie innerhalb der letzten 10 Jahre zugunsten Angehöriger getroffen?",
            detailsRequired:
              "Bitte beschreiben Sie die unentgeltlichen Verfügungen und Ihr Verwandtschaftsverhältnis zu den Angehörigen.",
          },
          otherDispositions: {
            question:
              "Haben Sie innerhalb der letzten 10 Jahre sonstige Verfügungen (etwa Verkauf, Vermietung) zugunsten Angehöriger getroffen?",
            questionRequired:
              "Bitte geben Sie an, ob Sie in den letzten 10 Jahren sonstige Verfügungen zugunsten Angehöriger getroffen haben.",
            details:
              "Welche sonstigen Verfügungen (etwa Verkauf, Vermietung) haben Sie innerhalb der letzten 10 Jahre zugunsten Angehöriger getroffen?",
            detailsRequired:
              "Bitte beschreiben Sie die sonstigen Verfügungen und Ihr Verwandtschaftsverhältnis zu den Angehörigen.",
          },
          assetSettlement: {
            question:
              "Hat innerhalb der letzten 10 Jahre eine Vermögensauseinandersetzung zwischen Ihnen und Ihren Angehörigen stattgefunden?",
            questionRequired:
              "Bitte geben Sie an, ob in den letzten 10 Jahren eine Vermögensauseinandersetzung mit Angehörigen stattgefunden hat.",
            details:
              "Welche Vermögensauseinandersetzung hat zwischen Ihnen und Ihren Angehörigen innerhalb der letzten 10 Jahre stattgefunden?",
            detailsRequired:
              "Bitte beschreiben Sie die Vermögensauseinandersetzung und Ihr Verwandtschaftsverhältnis zu den Angehörigen.",
            info: {
              intro:
                "Mit Vermögensauseinandersetzung ist gemeint, dass Vermögenswerte zwischen Personen aufgeteilt werden oder dass auf den Erwerb oder den Anspruch auf einen Vermögensgegenstand verzichtet wird.",
              assetsTitle: "Als Vermögen gilt zum Beispiel",
              assets: {
                cash: "Bargeld, Bankguthaben, sonstige Forderungen",
                securities: "Wertpapiere, Lebensversicherung, Bausparvertrag",
                valuables: "Wertgegenstände wie Schmuck, Kunstgegenstände, Antiquitäten",
                companies: "Unternehmen und Anteile an Unternehmen",
                realEstate: "Immobilienbesitz an Häusern, Grundstücken und Eigentumswohnungen",
                cooperative:
                  "Anteile an einer Genossenschaft (auch der Auszahlungsanspruch bei Auszug aus einer Genossenschaftswohnung)",
              },
              examplesTitle: "Eine Vermögensauseinandersetzung kann zum Beispiel sein",
              examples: {
                divorce: "Aufteilung von Vermögen nach einer Scheidung oder Verzicht auf Vermögensteile",
                sharedProperty: "Aufteilung von gemeinsamem Eigentum, etwa nach einer Erbschaft oder einer Scheidung",
                waiver: "Verzicht auf eine Erbschaft oder eine Schenkung",
                residenceRight:
                  "Einräumung eines Wohnrechts oder eines Fruchtgenussrechtes an einer Immobilie, die Sie besitzen",
                mortgages: "Einräumung von Hypotheken an Liegenschaften",
                pledges: "Einräumung von Pfandrechten an Vermögensgegenständen oder Forderungen",
                assignment: "Abtretung einer Forderung",
              },
            },
          },
        },
        dependants: {
          introTitle: "Liste der Angehörigen",
          introHelpTextLead: "Hier sind all jene Angehörigen anzugeben, die",
          introHelpItemEntitled: "unterhaltsberechtigt sind (z.B. minderjährige Kinder) oder",
          introHelpItemHousehold: "mit Ihnen im gemeinsamen Haushalt leben.",
          introExplanation:
            "Diese Angaben sind von besonderer Wichtigkeit, da das Existenzminimum u.a. von der Zahl der Unterhaltspflichten (=Sorgepflichten) abhängt. Je mehr Unterhaltspflichten, umso höher das Existenzminimum.",
          introMoreInfoText: "Weitere Informationen finden Sie",
          introMoreInfoLink: "hier",
          householdTitle: "Angehörige, die bei Ihnen im Haushalt wohnen",
          nonHouseholdTitle: "Angehörige, die nicht bei Ihnen im Haushalt wohnen",
          householdEmpty: "Keine Angehörigen im gemeinsamen Haushalt erfasst.",
          nonHouseholdEmpty: "Keine Angehörigen außerhalb des Haushalts erfasst.",
          addDependant: "Weitere/n Angehörige/n hinzufügen",
          addDialogTitle: "Angehörige/n hinzufügen",
          addDialogSubmit: "Hinzufügen",
          removeDependant: "Person löschen",
          age_one: "({{count}} Jahr)",
          age_other: "({{count}} Jahre)",
          firstName: "Vorname",
          firstNameInfo: "Es genügt hier, alleine den Vornamen einzugeben.",
          relationship: "Verhältnis",
          birthDate: "Geburtsdatum",
          livesInHousehold: "Wohnt der Angehörige bei Ihnen im Haushalt?",
          isJointlyLiable: "Haftet der Angehörige bei Ihren Schulden mit?",
          isEntitledToMaintenance: "Ist der Angehörige unterhaltsberechtigt?",
          hasToPayAlimony: "Müssen Sie für den Angehörigen Unterhalt (Alimente) zahlen?",
          monthlyAlimonyAmount: "Wie hoch ist der monatliche Unterhalt, den Sie für den Angehörigen zahlen müssen?",
          paidFullLastMonth: "Haben Sie letzten Monat die Alimente für den Angehörigen zur Gänze bezahlt?",
          fullyGarnishedLastMonth:
            "Wurden die Alimente für den Angehörigen letzten Monat in der vollen Höhe gepfändet?",
          notFullyPaidWarning: "Der laufende Unterhalt wird aktuell nicht zur Gänze bezahlt!",
          note: "Bemerkung",
          successfullySaved: "Angehörige erfolgreich gespeichert",
          documentsTitle: "Unterlagen zu Unterhaltspflichten",
          documentsMissing: "Es fehlen noch Unterlagen zu den Unterhaltspflichten!",
          removeDocument: "{{fileName}} löschen",
          undoRemoveDocument: "Löschen von {{fileName}} rückgängig machen",
          deleteDocumentsFailed: "Unterlagen konnten nicht gelöscht werden",
          relationshipOptions: {
            acquaintance: "Bekannte:r",
            parent: "Elternteil",
            exSpouse: "Ex-Gatte:in",
            exPartner: "Ex-Lebensgefährte:in",
            spouse: "Gatte:in",
            child: "Kind",
            partner: "Lebensgefährte:in",
            other: "Sonstige:r",
            unknown: "Unbekannt",
            relative: "Verwandte:r",
          },
          entitlementInfo: {
            paragraph1:
              "Kinder sind solange unterhaltsberechtigt, solange sie nicht selbsterhaltungsfähig sind. Wenn Sie oder das Kind selbst Familienbeihilfe bekommen, ist das Kind bestimmt unterhaltsberechtigt.",
            paragraph2:
              "Ehepartner gelten dann als Unterhaltspflicht, wenn sie weniger als 40% zum gemeinsamen Haushaltseinkommen beitragen. Wenn Sie also verheiratet sind, können Sie selbst <checkLink>hier überprüfen</checkLink>, ob Ihr Partner, Ihre Partnerin für Sie als Unterhaltspflicht gilt.",
            spouseCheckLinkAria: "Unterhaltspflicht des Partners, der Partnerin prüfen (öffnet in neuem Tab)",
            paragraph3: "LebensgefährtInnen sind grundsätzlich nicht unterhaltsberechtigt.",
          },
        },
      },
      srvProceeding: {
        sections: {
          application: "Antrag",
          proceedingData: "Verfahrensdaten",
          claimsSnapshot: "Verbindlichkeiten",
          assetSnapshot: "Vermögensverzeichnis",
          quotaAndCosts: "Quote und Kosten",
          course: "Verfahrensverlauf",
        },
        create: "Verfahren erstellen",
        emptyState: "Für diese Kund:in ist noch kein Verfahren vorhanden.",
        loadFailed: "Das Verfahren konnte nicht geladen werden.",
        list: {
          searchPlaceholder: "Verfahren durchsuchen",
          title: "Verfahren",
          titleWithFileNumber: "Verfahren {{fileNumber}}",
          titleWithOpeningDate: "Verfahren {{date}}",
          noMatch: "Kein Verfahren mit dieser Aktenzahl gefunden",
        },
        claimsSnapshot: {
          caption: "Verbindlichkeiten zum Zeitpunkt des Verfahrens",
          creditor: "Gläubiger:in",
          caseNumber: "GZ",
          registeredOn: "Angemeldet am",
          amount: "Betrag in €",
          total: "Summe der Anmeldungen",
          empty: "Keine Verbindlichkeiten erfasst",
          refresh: "Aktualisieren",
          refreshHint: "Die Verbindlichkeiten der Kund:in haben sich seither geändert.",
          refreshSuccess: "Verbindlichkeiten aktualisiert",
          refreshFailed: "Die Verbindlichkeiten konnten nicht aktualisiert werden.",
        },
        assetSnapshot: {
          caption: "Ausgaben zum Zeitpunkt des Verfahrens",
          maintenanceObligationCount: "Zu berücksichtigende Unterhaltspflichten",
          monthlyIncome: "Monatliches Einkommen",
          seizableAmount: "Aktuell pfändbarer Betrag",
          expensePosition: "Ausgaben (Art)",
          expenseAmount: "Höhe in €",
          totalExpenses: "Summe der Ausgaben",
          notAvailable: "Zum Zeitpunkt der Erstellung des Verfahrens lag kein Vermögensverzeichnis vor.",
          notTaken: "Dieses Verfahren wurde vor Einführung der Momentaufnahme angelegt; es liegen keine Werte vor.",
        },
        fields: {
          applicationDate: "Antrag am",
          counselingType: "Beratungsart",
          openingDate: "Eröffnung am",
          annulmentDate: "Aufhebungsdatum",
          court: "Gericht",
          fileNumber: "Aktenzahl",
          trustee: "Treuhänder",
          insolvencyAdministrator: "Masseverwalter",
          inactiveTrustee: "Treuhänder ist inaktiv – bitte anderen wählen oder Auswahl entfernen",
          inactiveInsolvencyAdministrator: "Masseverwalter ist inaktiv – bitte anderen wählen oder Auswahl entfernen",
          offeredQuota: "Quote angeboten",
          acceptedQuota: "Quote angenommen",
          proceedingCosts: "Verfahrenskosten",
          remark: "Bemerkung",
        },
        validation: {
          invalidFileNumber:
            "Bitte geben Sie die Aktenzahl ohne Gerichtskennung und ohne führende Nullen ein, z. B. 18 S 36/26 oder 18 S 36/26p",
          courtRequiredForFileNumber: "Bitte wählen Sie ein Gericht aus, wenn eine Aktenzahl eingegeben ist",
          courtWithoutFileNumberPrefix:
            "Für das gewählte Gericht ist kein Aktenzeichen Präfix hinterlegt. Bitte ergänzen Sie es unter Systemeinstellungen > Stammdaten > Gerichte",
        },
        course: {
          date: "Datum",
          type: "Typ",
          result: "Ergebnis",
          remark: "Bemerkung",
          addRow: "+ Zeile hinzufügen",
        },
        saveSuccess: "Verfahren erfolgreich gespeichert",
        saveFailed: "Das Verfahren konnte nicht gespeichert werden.",
        createSuccess: "Verfahren erfolgreich erstellt",
        createFailed: "Das Verfahren konnte nicht erstellt werden.",
        conflict: "Das Verfahren wurde inzwischen geändert. Bitte laden Sie die Seite neu.",
        notFound: "Das Verfahren existiert nicht mehr. Bitte laden Sie die Seite neu.",
      },
      bankruptcyChecklist: {
        banner:
          "Manche Schulden gelten als **nicht restschuldbefreiungsfähig** — bitte alle Punkte sorgfältig durchgehen.",
        antwortFehlt: "Antwort fehlt",
        saveSuccess: "Konkurs-Checkliste erfolgreich gespeichert",
        statusWarning: "Warnung / Antwort fehlt",
        statusComplete: "Vollständig",
        tabs: {
          dangerousDebts: "Gefährliche Schulden",
          specialDebts: "Besondere Schulden",
          bankruptcyCapability: "Konkursfähigkeit",
          bankruptcyConsequences: "Folgen der Konkurseröffnung",
        },
        sections: {
          wohnungskosten: "Wohnungskosten",
          strafen: "Polizei-, Verwaltungs-, Gerichts- und Finanzamtsstrafen",
          alimente: "Laufende Unterhaltszahlungen (Alimente)",
        },
        questions: {
          mietrueckstand: "Gibt es aktuell einen Mietrückstand?",
          betriebskosten: "Haben Sie einen Rückstand bei Betriebskosten (Strom, Gas, Fernwärme)?",
          offeneStrafen: "Gibt es offene Polizei-, Verwaltungs-, Gerichts- oder Finanzamtsstrafen?",
          ratenvereinbarung: "Haben Sie für die offenen Strafen Ratenvereinbarungen getroffen?",
          einhaltung: "Können Sie die Ratenvereinbarungen einhalten und halten Sie diese auch wirklich ein?",
          kinderMitUnterhalt: "Haben Sie Kinder, für die Sie Unterhalt (= Alimente) zahlen müssen?",
          vollenUnterhalt: "Zahlen Sie aktuell den vollen Unterhalt, den Sie zahlen müssen?",
          wirdGepfaendet: "Wird der Unterhalt gepfändet (= von Ihrem Einkommen abgezogen)?",
        },
        info: {
          mietrueckstand:
            "Sollten Sie in keiner Mietwohnung leben oder nicht selbst Mieter der Wohnung sein, so beantworten Sie diese Frage bitte mit ‚Nein'.",
          betriebskosten:
            "Schulden aufgrund von Fernwärme-, Strom- oder Gasrückständen in früheren Wohnungen sind hier nicht gemeint. Bei dieser Frage geht es nur um die aktuelle Wohnung.",
          strafen:
            "Offene Strafen können in einem Schuldenregulierungsverfahren (Privatkonkurs) nicht berücksichtigt werden. Sie müssen zur Gänze bezahlt werden. Gibt es bei Konkurseröffnung offene Strafen, für die keine Ratenvereinbarungen getroffen wurden, so muss mit der Verhängung des Ersatzarrestes gerechnet werden. Treffen Sie deshalb mit der zuständigen Behörde entsprechende Ratenvereinbarungen.",
        },
        warnings: {
          mietrueckstand:
            "Es darf keinen Mietrückstand geben!\nSolange es einen Mietrückstand gibt, ist die Regulierung ‚normaler' Schulden nicht möglich. Erledigen Sie deshalb zuerst Ihren Mietrückstand.",
          betriebskosten:
            "Es darf keinen Rückstand bei den laufenden Betriebskosten (Strom, Gas, Fernwärme) geben!\nSolange es in der aktuellen Wohnung Rückstände bei den laufenden Kosten wie Strom, Gas oder Fernwärme gibt, ist die Regulierung ‚normaler' Schulden nicht möglich. Erledigen Sie deshalb zuerst diese Rückstände.",
          strafen: "Es darf keine ‚ungeregelten' Strafen geben!",
          aliment: "Der laufende Unterhalt wird aktuell nicht bezahlt!",
        },
        specialDebts: {
          sections: {
            selbststaendigkeit: "Selbstständigkeit",
            unterhaltsrueckstaende: "Unterhaltsrückstände",
            deliktschulden: "Deliktschulden",
            zuletztGemachteSchulden: "Zuletzt gemachte Schulden",
          },
          questions: {
            fruehereSelbststaendigkeit: "Waren Sie in der Vergangenheit selbstständig?",
            aktuelleSelbststaendigkeit: "Sind Sie aktuell selbstständig?",
            aktuellerGewerbeschein: "Haben Sie aktuell einen (evt. ruhenden) Gewerbeschein?",
            gewerbe: "Wird die Selbstständigkeit als Gewerbe ausgeübt?",
            ruhend: "Ist der Gewerbeschein ruhend?",
            unterhaltsrueckstaende: "Gibt es Unterhaltsrückstände?",
            deliktschulden: "Gibt es Schulden, die im Zusammenhang mit einer strafbaren Handlung stehen?",
            kreditschulden: "Haben Sie Kreditschulden?",
            kreditzeitpunkt: "Wann haben Sie das letzte Mal einen Kredit aufgenommen / umgeschuldet?",
            versandhausschulden: "Haben Sie Versandhausschulden?",
            versandzeitpunkt: "Wann haben Sie das letzte Mal eine Versandhausbestellung gemacht?",
            nieGezahlt:
              "Gibt es Schulden, die Sie innerhalb der letzten 3 Jahre begründet haben, wo Sie nie eine Zahlung geleistet haben?",
          },
          answers: {
            kreditWithin: "innerhalb der letzten 5 Jahre",
            kreditBefore: "vor mehr als 5 Jahren",
            versandWithin: "innerhalb der letzten 3 Jahre",
            versandBefore: "vor mehr als 3 Jahren",
          },
          remarkLabel: "Bemerkung der Schuldnerberatung",
          info: {
            vergInfo:
              "Um zu klären, ob Sie für die Schulden Ihrer ehemaligen Firma haften, ist abzuklären, was für eine Firma Sie hatten (gemeint ist die Rechtsform z.B. GmbH, KEG, Einzelfirma …) und welche Funktion Sie in dieser Firma hatten.\n\n• **Einzelfirma:** Volle Haftung für alle Schulden, auch mit Privatvermögen.\n• **KEG/KG:** Komplementär (Geschäftsführer) haftet voll mit Privatvermögen; Kommanditist beschränkt auf Haftsumme (im Firmenbuch eingetragen).\n• **GmbH:** Geschäftsführer haftet für Abgaben (Finanzamt, SVA, GKK) + privat unterzeichnete Verbindlichkeiten; Gesellschafter beschränkt auf Stammeinlage (derzeit **10.000 €**).\n• **OHG/OEG:** Volle Haftung aller Gesellschafter mit Privatvermögen.\n• Für andere Rechtsformen: Hinweis auf Wirtschaftskammer.\n\n**Hinweis Aufrechnungsrecht:** SVA/GKK-Schulden bei gleichzeitigem Einkommen → Pfändungsgrenzen können unterschritten werden.\n**Hinweis Sanierungsgewinn:** Teilzahlung Finanzamt → mögliche steuerliche Abgabe bei späterer Einkommenssituation.",
            aktNichtGew: "Einkünfte aus einer Selbstständigkeit sind im Vermögensverzeichnis genau anzugeben.",
            gewRuhend:
              "Wenn Ihr Gewerbeschein aktiv ist, ist anzunehmen, dass Sie ihr Gewerbe ausüben und daraus zusätzliche Einkünfte haben. Diese sind im Vermögensverzeichnis genau anzugeben. Falls Sie ihr Gewerbe nicht ausüben, ist anzuraten, den Gewerbeschein zurückzulegen. Ruhend gestellte Gewerbescheine sind im Privatkonkurs kein Problem, es besteht aber die Möglichkeit, dass sie entzogen werden.",
            unthInfo:
              "Hier sind Infos über Unterhaltsrückstände\n• im Konkurs\n• im Zahlungsplan\n• im Abschöpfungsverfahren\n• nach Restschuldbefreiung\n• etc.\nzu geben.",
            infoDelikt:
              "Schulden, die in Zusammenhang mit einer strafbaren Handlung stehen, können unter Umständen auch nach erfolgreicher Beendigung eines Privatkonkurses weiter bestehen bleiben. Diese Umstände treten ein, wenn das **Abschöpfungsverfahren** eingeleitet wird. Einige Beispiele für Deliktschulden (unvollständige Aufzählung): Schadenersatzforderung wegen Betruges, Diebstahl, Schmerzengeld aufgrund einer vorsätzlichen Körperverletzung, Autounfall in betrunkenem Zustand, Verletzung der Unterhaltspflicht.",
            deliktInfo:
              "Deliktschulden sind im Abschöpfungsverfahren von einer **Restschuldbefreiung** ausgenommen.\nBeim **Zahlungsplan** gibt es keinen Unterschied zwischen ‚normalen' Schulden und Deliktschulden.",
          },
          warnings: {
            kreditWarn:
              "Klären Sie bitte mit der Schuldnerberatung, ob eine Vermögensverschleuderung bzw. eine Begründung einer unverhältnismäßigen Verbindlichkeit vorliegt.\nBesprechen Sie bitte mit der Schuldnerberatung die näheren Umstände der letzten Kreditaufnahme. Es geht darum, abzuklären, ob eventuelle **Einleitungshindernisse** vorliegen. Wenn ein Einleitungshindernis besteht, kann das **Abschöpfungsverfahren** nicht eingeleitet werden, was meist auch bedeutet, dass die Gläubiger einem **außergerichtlichen Ausgleich** bzw. einem **Zahlungsplan** nicht zustimmen.",
            versandWarn: "Es liegt evt. ein Einleitungshindernis vor, klären Sie das mit der Schuldnerberatung.",
            nieGezWarn:
              "Achtung: Gefahr einer Betrugsanzeige bzw. Einleitungshindernis\nBesprechen Sie die näheren Umstände bitte mit der Schuldnerberatung.",
          },
        },
        bankruptcyConsequences: {
          intro:
            "Die Fragen auf dieser Seite dienen dazu, Sie gezielt über eventuell unangenehme Folgen der Konkurseröffnung zu informieren.",
          sections: {
            girokonto: "Aktuelles Girokonto",
            mobiltelefon: "Mobiltelefon",
            stromGas: "Strom / Gas",
            fernwaerme: "Fernwärme",
          },
          questions: {
            eigenesGirokonto: "Haben Sie ein eigenes Girokonto?",
            kontoUeberzogen: "Ist das Konto aktuell überzogen / im Minus?",
            mobiltelefon: "Haben Sie ein auf Sie angemeldetes Mobiltelefon in Verwendung?",
            stromEigenerName:
              "Läuft der Strombezug der Wohnung, in der Sie jetzt wohnen, auf Ihren Namen? (Haben Sie einen Stromliefervertrag mit Wien Energie abgeschlossen?)",
            wohnungFernwaerme: "Wird Ihre aktuelle Wohnung mit Fernwärme geheizt?",
            fernwaermeEigenerName:
              "Läuft der Fernwärmebezug der Wohnung auf Ihren Namen? (Haben Sie einen Energieliefervertrag mit der Fernwärme Wien?)",
          },
          info: {
            infoKonto:
              "Wenn Sie das Konto eines anderen mitbenutzen und selbst nicht Kontoinhaber:in sind, so wählen Sie bitte ‚Nein'.",
            kontoJa: "Bei Konkurseröffnung besteht die Gefahr, dass Ihr aktuelles Girokonto gesperrt wird …",
            minusInfo:
              "Wenn das aktuelle Konto bei Konkurseröffnung im Minus ist, ist das Kontominus eine Konkursforderung. Mögliche Optionen:\n• Kontominus ausgleichen\n• Kontowechsel zu einem nicht überzogenen Konto",
            handyInfo:
              "Bei Konkurseröffnung besteht die Gefahr, dass das auf Sie angemeldete Handy seitens Ihres Mobilfunkbetreibers gesperrt wird …",
            stromInfo:
              "Sie können von Wien Energie aufgefordert werden, den Vertrag neu zu unterschreiben und eine Kaution zu hinterlegen.",
            fernwInfo:
              "Sie können von der Fernwärme aufgefordert werden, den Vertrag neu zu unterschreiben und eine Kaution zu hinterlegen.",
          },
        },
        bankruptcyCapability: {
          title: "Konkursfähigkeit",
          autoValuesNotice:
            "Die folgenden Werte werden automatisch aus dem Vermögensverzeichnis übernommen. Es sind keine Eingaben erforderlich.",
          fields: {
            monthlyIncome: "Monatliches Gesamteinkommen",
            monthlyExpenses: "Monatliche Ausgaben",
            seizableAmount: "Pfändbarer Betrag (inkl. Unterhaltspflichten)",
            result: "Ergebnis",
            fromAssetInventory: "aus dem Vermögensverzeichnis",
            seizableHint: "unter Berücksichtigung von {{count}} Unterhaltspflicht(en)",
          },
          noData: {
            title: "Vermögensverzeichnis noch nicht erfasst",
            text: "Die Auswertung der Konkursfähigkeit basiert auf den Angaben aus dem **Vermögensverzeichnis**. Für diese:n Kund:in wurden die erforderlichen Daten dort noch nicht erfasst.\n\nBitte erfassen Sie zuerst die Angaben zu **Einkommen**, **Ausgaben** und **Unterhaltspflichten** im Vermögensverzeichnis. Anschließend wird die Konkursfähigkeit hier automatisch berechnet und angezeigt.",
            requiredTitle: "Benötigte Angaben",
            required: {
              income: "Monatliches Gesamteinkommen",
              expenses: "Monatliche Ausgaben",
              maintenance: "Anzahl der Unterhaltspflichten",
            },
            linkLabel: "Zum Vermögensverzeichnis",
          },
          result: {
            givenTitle: "Ergebnis: Konkursfähigkeit gegeben",
            notGivenTitle: "Ergebnis: Keine Konkursfähigkeit gegeben",
            notGiven:
              "Da Sie über **kein pfändbares Einkommen** verfügen, ist grundsätzlich **keine Konkursfähigkeit gegeben**. Um Ihre Schulden zuverlässig regulieren zu können, wird es daher notwendig sein, einen gewissen Betrag aus Ihrem unpfändbaren Einkommen oder von dritter Seite aufzubringen.",
            given:
              "Sie haben ein monatliches Gesamteinkommen von **{{income}}** angegeben. Ihre monatlichen Ausgaben betragen **{{expenses}}**. Unter Berücksichtigung von **{{count}} Unterhaltspflicht(en)** sind durchschnittlich **{{amount}}** pro Monat pfändbar. Da Sie über pfändbares Einkommen verfügen, ist **Konkursfähigkeit grundsätzlich gegeben**.",
          },
        },
      },
    },
  },
  measuresCauses: {
    title: "Verschuldung",
    measuresLabel: "Maßnahmen",
    causesLabel: "Ursachen",
    addMeasure: "Maßnahme hinzufügen",
    addCause: "Ursache hinzufügen",
    deleteRow: "Eintrag löschen",
    saveSuccess: "Maßnahmen/Ursachen erfolgreich gespeichert",
    measure: "Maßnahme",
    cause: "Ursache",
    measureRequired: "Maßnahme ist erforderlich",
    causeRequired: "Ursache ist erforderlich",
  },
  goalsResults: {
    title: "Ziele/Ergebnisse",
    achievementDate: "Datum der Erreichung",
    goalResult: "Ziel/Ergebnis",
    addButton: "Ziel /Ergebnis hinzufügen",
    saveSuccess: "Ziele/Ergebnisse erfolgreich gespeichert",
    deleteSuccess: "Eintrag erfolgreich gelöscht",
    deleteRow: "Eintrag löschen",
    resetDialog: {
      title: "Änderungen zurücksetzen",
      text: "Möchten Sie alle ungespeicherten Änderungen wirklich zurücksetzen?",
    },
  },
  filters: {
    salutation: "Anrede: {{value}}",
    title: "Titel: {{value}}",
    name: "Name: {{value}}",
    birthday: "Geburtsdatum: {{value}}",
    insuranceNumber: "SV-Nummer: {{value}}",
    caseNumber: "EDV-Nummer: {{value}}",
    srvFileNumber: "SRV-Aktenzahl: {{value}}",
    courtId: "Gericht: {{value}}",
    street: "Straße: {{value}}",
    zipCode: "PLZ: {{value}}",
    city: "Ort: {{value}}",
    nationality: "Staatsbürgerschaft: {{value}}",
    mediaInquiry: "Medienanfrage: {{value}}",
    caseNoteDateFrom: "AV Datum von: {{value}}",
    caseNoteDateTo: "AV Datum bis: {{value}}",
    caseNoteKeyword: "Stichwort: {{value}}",
    assignedCounselorId: "Bearbeiter: {{value}}",
    status: "Aktueller Status: {{value}}",
    searchText: "Suche: {{value}}",
  },
};

export default clients;
